import React from 'react';
const intl = {
  headlineQuote: {
    'en': <span>When organizations deliver exceptional customer<br />
      experiences they make it look so easy<br />
      - even when it's not</span>,
    'dk': <span>Når organisationer leverer ekseptionelle <br />
      kundeoplevelser får de det til at se let ud<br />
      – selv når det ikke er.</span>
  },
  contactinfo: {
    openHours: {
      'en': 'Opening hours',
      'dk': 'Åbningstider',
    },
    contact: {
      'en': 'Contact',
      'dk': 'Kontakt',
    },
    location: {
      'en': 'Copenhagen, Denmark',
      'dk': 'København, Danmark',
    }
  },
  block1: {
    headline: {
      'en': 'The Institute of Leadership Dynamics',
      'dk': 'The Institute of Leadership Dynamics'
    },
    body: {
      'en': <div>
        We deliver services and assistance to SMEs that wish to enhance their ability to generate sustainable results and true competitive advantages – and continue to do so.
        <br /><br />
        We focus on what is needed to generate such performance: people and the relationships they form. This is where we place our focus and help our clients achieve enduring success through culture and people.
        <br /><br />
        We pay attention to what true leadership means for the organization. How does leadership impact culture? How does organizational culture affect performance and results in both short and long term? Why do relationships matter between people within the organization and between employees and customers?
        <br /><br />
        However straightforward this sounds in the abstract, we are deeply aware of how complex it can be in reality. We look forward to telling you more about what we care deeply about and how we can help you.
      </div>,
      'dk': <div>
        Vi leverer tjenester og ydelser til virksomheder, der ønsker at styrke deres organisations evne til at skabe blivende resultater og sikre deres fremadrettede konkurrencemæssige fordele.
        <br /><br />
        Vi er bevidste om, at det er mennesker, der skaber disse resultater og at det er relationerne mellem disse mennesker der sikrer kvaliteten i deres resultatløsning. Det hjælper vi dem med at sikre og skabe gennem kultur.
        <br /><br />
        Vi er meget opmærksomme på, hvilken betydning ledelse har for organisationen. Hvilken form for ledelse kræver det at skabe en sund organisationskultur, der præsterer og leverer resultater? Hvilken kultur skal præge virksomheden – ikke i år eller til næste – men altid! Hvordan ønsker vi at behandle medarbejdere og hvordan skal de behandle vores kunder?
        <br /><br />
        Det lyder enkelt og ligetil, men det er det ikke og vores tilgang og metode tager højde for kompleksiteten og skaber fremdrift. Vi ser frem til en snak om hvordan det vi brænder for kan hjælpe dig med det, der er vigtigt for dig.
      </div>
    }
  },
  block3: {
    headline: {
      'en': <div style={{ textAlign: 'center', paddingBottom: '20px' }}>
        {/* <div style={{ color: '#c0c0c0', fontSize: '14px', lineHeight: '10px' }}>On leadership</div> */}
        <div style={{ color: '#000', fontWeight: 700, fontSize: '14px' }}><i>The Three pillars of Leadership</i></div>
      </div>,
      'dk': <div style={{ textAlign: 'center', paddingBottom: '20px' }}>
        {/* <div style={{ color: '#c0c0c0', fontSize: '14px', lineHeight: '10px' }}>On leadership</div> */}
        <div style={{ color: '#000', fontWeight: 700, fontSize: '14px' }}><i>Lederskabet bygger på 3 søjler</i></div>
      </div>
    },
    body: {
      'en': <div style={{ textAlign: 'center' }}>
        A leader is the epicenter of any organization. By enabling the organization to succeed, the leader is the single most influential individual in an organization. The role itself is no guarantee of world-class leadership. The two – a leadership role and world-class leadership – are not mutually inclusive. Leadership first exists when followership occurs; when someone decides to accept someone else’s lead, to receive their guidance and direction.
        <br /><br />
        That is not role-dependent. It is determined by the individual in the role and their behavior. A reflection of both character and personality and it is grounded in the three succinct pillars.
      </div>,
      'dk': <div style={{ textAlign: 'center' }}>
        Lederen er den person, der i kraft af sin rolle har den største indflydelse på organisationens evne til at skabe resultater. Rollen i sig selv er ingen garanti for et velfungerende og resultatskabende lederskab. Det opstår først når lederen formår at skabe følgeskab - når medarbejderne vælger at følge lederen i den retning der udstikkes.
        <br /><br />
        Det er ikke givet af rollen alene – det er i høj grad lederens adfærd der reflekterer både personlighed og karakter, der skaber dette vigtige følgeskab.
      </div>
    },
    buttonTxt: {
      'en': 'Read more about our tools',
      'dk': 'Læs mere om vores værktøjer',
    }
  },
  block5: {
    subheadline: {
      'en': 'LIFE IS ABOUT OPPORTUNITIES',
      'dk': 'LIVET HANDLER OM MULIGHEDER'
    },
    headline: {
      'en': <span>The opportunities around us are infinite. If only we dare to look for them, and have courage to do what it takes, whether it's change of direction, structure or event strategy. <br/><br/>
      Well, sometimes it's just ourselves we need to change!</span>,
      'dk': <span>Mulighederne omkring os er uendelige. Hvis vi tør kigge op og har modet til gøre det, der kræves. Uanset om det er at ændre retning, struktur – eller strategi!.. og nogle gange er det 'bare' os selv der skal turde forandring!</span>
    }
  }

}

export default intl;



// WEBPACK FOOTER //
// ./src/pages/Home/intl.js